'use client';

import { PageHeader } from '@/app/(app)/page-main';
import { EmployeeEditingProvider, useEmployeeEditingCtx } from '@/app/(app)/settings/employees/[id]/provider';
import { EmployeeDetails } from '@/app/(app)/settings/employees/[id]/tab-details';
import { EmployeeLocations } from '@/app/(app)/settings/employees/[id]/tab-locations';
import { EmployeeSkillsAndRegions } from '@/app/(app)/settings/employees/[id]/tab-skills';
import { PageTabsList, PageTabsTrigger, Tabs, TabsContent } from '@/components/ui/tabs';
import { useLocationParam } from "@/lib/router";

export function EmployeePage() {
  const id = useLocationParam('id');
  return (
    <EmployeeEditingProvider id={id}>
      <PageContent />
    </EmployeeEditingProvider>
  );
}


function PageContent() {
  const { name } = useEmployeeEditingCtx();

  return (
    <Tabs defaultValue='general'>
      <div>
        <PageHeader title={name} breadcrumbs={[{ label: 'Employees', href: '/settings/employees' }]} />
        <div className='mt-2 border-b-[0.5px] px-4'>
          <PageTabsList className=''>
            <PageTabsTrigger value='general'>General</PageTabsTrigger>
            <PageTabsTrigger value='skills-and-regions'>Skills & Regions</PageTabsTrigger>
            <PageTabsTrigger value='locations'>Locations</PageTabsTrigger>
          </PageTabsList>
        </div>
        <div className='mx-auto mt-14 w-full max-w-2xl px-4 lg:px-0'>
          <TabsContent value='general'>
            <EmployeeDetails />
          </TabsContent>
          <TabsContent value='skills-and-regions'>
            <EmployeeSkillsAndRegions />
          </TabsContent>
          <TabsContent value='locations'>
            <EmployeeLocations />
          </TabsContent>
        </div>
      </div>
    </Tabs>
  );
}
